// Modules
import Common from "./modules/common";
import YTVideo from "./modules/yt-video";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import QCF from "./modules/qcf";
import blockDistribution from "./modules/block-distribution";

// Autoload modules
const modules = [
  Common,
  YTVideo,
  Animate,
  Header,
  Lightbox,
  QCF,
  blockDistribution,
];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import singlePost from "./partials/single-post";
import templateContacts from "./partials/template-contacts";
import singleProduct from "./partials/single-product";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  singlePost,
  singleProduct,
  templateContacts,
});

// Load Events
routes.loadEvents();
